
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Buscar/NotFoundText",
      function () {
        return require("private-next-pages/Buscar/NotFoundText.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Buscar/NotFoundText"])
      });
    }
  